import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import intl from 'react-intl-universal';


import Button from '../../../../components/Button/index';
import './DrawerButton.css';

@inject("appStore")
@observer
class DrawerButton extends Component {
    constructor(props) {
        super(props);
        this.iconDrawers = {
            polyline: {
                text: intl.get("polyline"),
                instructions: intl.get("IconDrawer.instructions"),
                icon: "imgs/route_white.png"
            },
            marker: {
                text: intl.get("icon"),
                instructions: intl.get("IconDrawer.instructions"),
                icon: "imgs/marker_white.png"
            },
            polygon: {
                text: intl.get("polygon"),
                instructions: intl.get("IconDrawer.instructions"),
                icon: "imgs/shape_white.png"
            }
        }
    };

    switchActiveDrawer = () => {
        if (this.props.appStore.editMode) return;
        if (!this.props.appStore.drawer.open) {
            this.props.appStore.setDrawer({open: true, active: this.props.questionType});
        } else {
            if (this.props.appStore.drawer.active === this.props.questionType) {
                this.props.appStore.setDrawer({open: !this.props.appStore.drawer.open, active: this.props.questionType});
            } else {
                this.props.appStore.setDrawer({active: this.props.questionType});
            }
        }
    };

    render() {
        let className = 'drawerType';
        if (this.props.appStore.drawer.active === this.props.questionType) {
            className = className + ' active';
        } else if (this.props.appStore.editMode) {
            className = className + ' disabled';
        }
        return (
            <div className="DrawerButton">
                <Button className={className}
                        onClick={() => this.switchActiveDrawer()}>
                    <div className={"image " + this.props.questionType}>
                        <img src={this.iconDrawers[this.props.questionType].icon} alt={this.props.questionType}
                             aria-hidden="true"/>
                    </div>
                    <div className="buttonCopy">
                        <span className="instructions">{this.iconDrawers[this.props.questionType].instructions}</span>
                        <span>{" "}</span>
                        <span className="text">{this.iconDrawers[this.props.questionType].text}</span>
                    </div>
                </Button>
            </div>
        );
    }
}

export default DrawerButton;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/DrawerButton/index.js